import { DataProvider } from "@refinedev/core";
import { REVALIDATE_TIME } from "@shared/constants";
import { toCamel } from "@shared/utils";

export interface CustomDataProvider extends DataProvider {
  custom: (params: {
    method: string;
    url: string;
    payload?: any;
    headers?: any;
    options?: any;
  }) => Promise<{ data: any }>;
}

const customFetch = async (url: string, options?: RequestInit) => {
  return fetch(url, {
    ...options,
    cache: options?.cache ?? "force-cache",
    next: options?.next ?? { revalidate: REVALIDATE_TIME },
  });
};

function extractError(error: any): string {
  let message = "";
  if (error && error.message) {
    message += error.message;
  }

  if (error && error.fails) {
    message += "\n" + JSON.stringify(error.fails);
  }

  return message;
}

export const restDataProvider = (url: string): CustomDataProvider => ({
  getOne: async () => {
    throw new Error("Not implemented");
  },
  getMany: async () => {
    throw new Error("Not implemented");
  },
  getList: async () => {
    throw new Error("Not implemented");
  },
  create: async () => {
    throw new Error("Not implemented");
  },
  update: async () => {
    throw new Error("Not implemented");
  },
  deleteOne: async () => {
    throw new Error("Not implemented");
  },
  getApiUrl: () => url,
  custom: async ({ method, url: path, payload, headers, options }) => {
    const response = await customFetch(`${url}${path}`, {
      method,
      body: payload ? JSON.stringify(payload) : undefined,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...headers,
      },
      ...options,
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      const message = data?.message || (data.error ? extractError(data.error) : null) || response.statusText || "Unknown error";

      throw new Error(message);
    }

    return {
      data: toCamel(data),
    };
  },
});